import { render, staticRenderFns } from "./refundExplain.vue?vue&type=template&id=28be5fb5&scoped=true"
import script from "./refundExplain.vue?vue&type=script&lang=js"
export * from "./refundExplain.vue?vue&type=script&lang=js"
import style0 from "./refundExplain.vue?vue&type=style&index=0&id=28be5fb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be5fb5",
  null
  
)

export default component.exports